var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.541676 13.1767C0.541676 12.6983 0.938342 12.3017 1.41668 12.3017L5.96667 12.3017C6.44501 12.3017 6.84167 12.6983 6.84167 13.1767C6.84167 13.655 6.44501 14.0517 5.96667 14.0517L1.41668 14.0517C0.938342 14.0517 0.541676 13.655 0.541676 13.1767Z",
    fill: "#34415A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4333 13.1767C13.4333 12.6983 13.83 12.3017 14.3083 12.3017L16.5833 12.3017C17.0616 12.3017 17.4583 12.6983 17.4583 13.1767C17.4583 13.655 17.0616 14.0517 16.5833 14.0517L14.3083 14.0517C13.83 14.0517 13.4333 13.655 13.4333 13.1767Z",
    fill: "#34415A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36662 13.1767C7.36662 11.0183 9.11662 9.26833 11.275 9.26833C13.4333 9.26833 15.1833 11.0183 15.1833 13.1767C15.1833 15.335 13.4333 17.085 11.275 17.085C9.11662 17.085 7.36662 15.3233 7.36662 13.1767ZM13.4333 13.1767C13.4333 11.9867 12.465 11.0183 11.275 11.0183C10.085 11.0183 9.11662 11.9867 9.11662 13.1767C9.11662 14.3667 10.085 15.335 11.275 15.335C12.465 15.335 13.4333 14.355 13.4333 13.1767Z",
    fill: "#34415A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.541651 4.82333C0.541651 4.345 0.938317 3.94833 1.41665 3.94833L3.69165 3.94833C4.16998 3.94833 4.56665 4.345 4.56665 4.82333C4.56665 5.30167 4.16998 5.69833 3.69165 5.69833L1.41665 5.69833C0.938317 5.69833 0.541651 5.31333 0.541651 4.82333Z",
    fill: "#34415A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1583 4.82333C11.1583 4.345 11.555 3.94833 12.0333 3.94833L16.5833 3.94833C17.0616 3.94833 17.4583 4.345 17.4583 4.82333C17.4583 5.30167 17.0616 5.69833 16.5833 5.69833L12.0333 5.69833C11.555 5.69833 11.1583 5.31333 11.1583 4.82333Z",
    fill: "#34415A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81663 4.82333C2.81664 2.665 4.56663 0.915001 6.72497 0.915001C8.8833 0.915001 10.6333 2.665 10.6333 4.82333C10.6333 6.98167 8.8833 8.73167 6.72497 8.73167C4.56663 8.73167 2.81663 6.98167 2.81663 4.82333ZM8.8833 4.82333C8.8833 3.63333 7.91497 2.665 6.72497 2.665C5.53497 2.665 4.56663 3.63333 4.56663 4.82333C4.56663 6.01333 5.53497 6.98167 6.72497 6.98167C7.91497 6.98167 8.8833 6.025 8.8833 4.82333Z",
    fill: "#34415A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.b9bbcb54a77bc19095cd189ebd53ed0b.svg";
export { ForwardRef as ReactComponent };